import { stableStringify, toHash } from '../helpers.js';

export const keyframes = (keyframe) => {
  const prefix = "ids"
  const wrap = (base) => (prefix ? prefix + '-' + base : base)
  const block = keyframe && typeof keyframe === 'object' ? keyframe : {}
  return wrap('kf_' + toHash(stableStringify(block)))
}